import { faQrcode } from '@fortawesome/free-solid-svg-icons';

import Checkmark from "../picture/checkmark.svg?react";
import Cross from "../picture/cross.svg?react";

const Icons = {
	'barcode': faQrcode,
	'checkmark.svg': Checkmark,
	'cross.svg': Cross 
};

export default Icons;
